(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-wc-gallery]').forEach((gallery) => {
      if (gallery.dataset.wcReady) return;
      gallery.dataset.wcReady = 'true';
      gallery.addEventListener('click', (event) => {
        const button = event.target.closest('[data-wc-gallery-target]');
        if (!button) return;
        const target = button.dataset.wcGalleryTarget;
        gallery.querySelectorAll('[data-wc-gallery-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.wcGalleryPanel !== target;
        });
        gallery.querySelectorAll('[data-wc-gallery-target]').forEach((control) => {
          control.setAttribute('aria-pressed', String(control === button));
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
